var map = {
	"./1factory.png": 1662,
	"./3D Infotech.png": 1663,
	"./3D Systems.png": 1664,
	"./4Industry.png": 1665,
	"./6 River Systems.png": 1666,
	"./AAEON.png": 1667,
	"./ABB.png": 1668,
	"./ADVANTECH.png": 1669,
	"./ANOVA Consulting Group.png": 1670,
	"./AVEVA.png": 1671,
	"./AVIX.png": 1672,
	"./Abbott.png": 1673,
	"./Accenture.png": 1674,
	"./Adeunis.png": 1675,
	"./Advantech.png": 1676,
	"./Aeternity.png": 1677,
	"./Airobotics.png": 1678,
	"./Alfa Laval.png": 1679,
	"./Amazon Web Services.png": 1680,
	"./Ammeraal Beltech.png": 1681,
	"./Ancra.png": 1682,
	"./Ansys.png": 1683,
	"./Apex Supply Chain.png": 1684,
	"./Appnovation.png": 1685,
	"./Aptean.png": 1686,
	"./Arena Solutions.png": 1687,
	"./Arena.png": 1688,
	"./Arestech Co., Ltd.png": 1689,
	"./Asahi America Inc..png": 1690,
	"./Asahi America.png": 1691,
	"./Aspen Technologies.png": 1692,
	"./Aspen Technology.png": 1693,
	"./AspenTech.png": 1694,
	"./Astera.png": 1695,
	"./Atlantech Process Technology.png": 1696,
	"./Aubo Robotics.png": 1697,
	"./Augury.png": 1698,
	"./AutoCrib.png": 1699,
	"./Autodesk.png": 1700,
	"./Automation Anywhere.png": 1701,
	"./BEHAbelt.png": 1702,
	"./BIOVIA DSS.png": 1703,
	"./BMC.png": 1704,
	"./BT.png": 1705,
	"./Bain & Company.png": 1706,
	"./Balyo.png": 1707,
	"./Banner Engineering.png": 1708,
	"./Bastian Solutions.png": 1709,
	"./Baumer.png": 1710,
	"./BeAM.png": 1711,
	"./Beckhoff Automation.png": 1712,
	"./Belden.png": 1713,
	"./Billon.png": 1714,
	"./Birst.png": 1715,
	"./BluJay Solutions.png": 1716,
	"./Blue Yonder.png": 1717,
	"./BlueBotics.png": 1718,
	"./BluePrism.png": 1719,
	"./Bluepath.png": 1720,
	"./Blueprism.png": 1721,
	"./Blujay Solutions.png": 1722,
	"./Bosch Software Innovations.png": 1723,
	"./Brenton Engineering.png": 1724,
	"./British Telecoms.png": 1725,
	"./Brother USA.png": 1726,
	"./Bruel & Kjaer Vibro.png": 1727,
	"./CAMCORP.png": 1728,
	"./CQM Training _ Consultancy.png": 1729,
	"./Canon.png": 1730,
	"./Carbon.png": 1731,
	"./Carel 1.png": 1732,
	"./Carel 2.png": 1733,
	"./Carel.png": 1734,
	"./Cascade Insights.png": 1735,
	"./Celonis.png": 1736,
	"./Center for Creative Leadership.png": 1737,
	"./Cisco-Eagle.png": 1738,
	"./Cisco.png": 1739,
	"./Clearswift.png": 1740,
	"./Cloudera.png": 1741,
	"./Clozd.png": 1742,
	"./Cognex.png": 1743,
	"./Cognizant.png": 1744,
	"./Comau.png": 1745,
	"./Combi Packaging Systems.png": 1746,
	"./Compacer.png": 1747,
	"./Compliance Quest.png": 1748,
	"./ComplianceQuest.png": 1749,
	"./Convergence Training.png": 1750,
	"./Coperion.png": 1751,
	"./Cority.png": 1752,
	"./Coursera.png": 1753,
	"./Cousins Packaging.png": 1754,
	"./Cryptyk.png": 1755,
	"./CyberTec.png": 1756,
	"./DJI.png": 1757,
	"./DNC.png": 1758,
	"./DS Smith.png": 1759,
	"./DYNAMICS365 REMOTE ASSIST.png": 1760,
	"./Daifuku.png": 1761,
	"./Dale Carnegie.png": 1762,
	"./DataValue Consulting.png": 1763,
	"./Dell.png": 1764,
	"./Della Toffola.png": 1765,
	"./Deloitte Consulting.png": 1766,
	"./Deloitte.png": 1767,
	"./Delta Electronics.png": 1768,
	"./Delta.png": 1769,
	"./Dematic.png": 1770,
	"./Demisto.png": 1771,
	"./Desktop Metal.png": 1772,
	"./Domino Printing.png": 1773,
	"./Domo.png": 1774,
	"./Doosan Robotics.png": 1775,
	"./DoubleCheck Research.png": 1776,
	"./Dundas.png": 1777,
	"./Dynamics 365.png": 1778,
	"./ECOLAB.png": 1779,
	"./EON Solutions.png": 1780,
	"./ETQ.png": 1781,
	"./EVOCON.png": 1782,
	"./EY.png": 1783,
	"./EZOfficeInventory.png": 1784,
	"./Efeso.png": 1785,
	"./Ekso Bionics.png": 1786,
	"./Elementary Robotics.png": 1787,
	"./Elemica.png": 1788,
	"./Elettric80.png": 1789,
	"./Elletric 80.png": 1790,
	"./Emerson.png": 1791,
	"./Emex.png": 1792,
	"./Enablon.png": 1793,
	"./Endress+Hauser.png": 1794,
	"./Enovia.png": 1795,
	"./Epicor.png": 1796,
	"./Ericsson.png": 1797,
	"./Ernst & Young.png": 1798,
	"./Evocon.png": 1799,
	"./Exyn Technologies.png": 1800,
	"./FANUC.png": 1801,
	"./FalconStor.png": 1802,
	"./Falkonry.png": 1803,
	"./Fenner Dunlop.png": 1804,
	"./Fero Labs.png": 1805,
	"./Festo.png": 1806,
	"./Fetch Robotics.png": 1807,
	"./Fibonacci Lab.png": 1808,
	"./Fictiv(1).png": 1809,
	"./Fictiv.png": 1810,
	"./Fiix.png": 1811,
	"./Fishbowl-.png": 1812,
	"./Fishbowl.png": 1813,
	"./Flexco Industries.png": 1814,
	"./Fluke.png": 1815,
	"./Fluxicon.png": 1816,
	"./FogHorn.png": 1817,
	"./Formax.png": 1818,
	"./Fresh Works.png": 1819,
	"./Future Pipe Industries.png": 1820,
	"./GAO RFID.png": 1821,
	"./GE Digital.png": 1822,
	"./GEA Group.png": 1823,
	"./GF Piping Systems.png": 1824,
	"./Generalscan.png": 1825,
	"./Gensuite.png": 1826,
	"./German Bionic Systems.png": 1827,
	"./Getac.png": 1828,
	"./Global Shop Solutions.png": 1829,
	"./Google.png": 1830,
	"./Gorbel.png": 1831,
	"./Group50.png": 1832,
	"./Guhring.png": 1833,
	"./HCL.png": 1834,
	"./HP.png": 1835,
	"./Habasit AG.png": 1836,
	"./Harvard.png": 1837,
	"./Hauni.png": 1838,
	"./Herma.png": 1839,
	"./Hewlett Packard Enterprise.png": 1840,
	"./Hewlett Packard.png": 1841,
	"./Highjump.png": 1842,
	"./Hippo CMMS.png": 1843,
	"./Hirschmann.png": 1844,
	"./Hitachi.png": 1845,
	"./Honeywell AIDC.png": 1846,
	"./Honeywell Intelligrated.png": 1847,
	"./Honeywell.png": 1848,
	"./Hortonworks.png": 1849,
	"./Huawei.png": 1850,
	"./Hurco.png": 1851,
	"./Hyperscience.png": 1852,
	"./IBM.png": 1853,
	"./ICS Group.png": 1854,
	"./ID Services Taipei.png": 1855,
	"./IFS.png": 1856,
	"./IMD.png": 1857,
	"./INFICON.png": 1858,
	"./INFORM.png": 1859,
	"./IQMS.png": 1860,
	"./Idhammar Systems.png": 1861,
	"./Imanpack.png": 1862,
	"./Industrial Vision Systems.png": 1863,
	"./Infineon.png": 1864,
	"./InfinityQs.png": 1865,
	"./Infor.png": 1866,
	"./Informatica.png": 1867,
	"./Infsoft.png": 1868,
	"./Intelex.png": 1869,
	"./Intelez.png": 1870,
	"./Intertek.png": 1871,
	"./Inther.png": 1872,
	"./Intralox.png": 1873,
	"./Invata Intralogistics.png": 1874,
	"./JASO.png": 1875,
	"./JBT.png": 1876,
	"./Jda.png": 1877,
	"./Johnson Controls.png": 1878,
	"./Joloda.png": 1879,
	"./KOAMTAC.png": 1880,
	"./KUKA.png": 1881,
	"./KaiNexus.png": 1882,
	"./Kaizen Institute.png": 1883,
	"./Keegan Consulting Group.png": 1884,
	"./Kenna Security.png": 1885,
	"./Kofax.png": 1886,
	"./Konecranes.png": 1887,
	"./Kontron S&T.png": 1888,
	"./Krones.png": 1889,
	"./Kyocera.png": 1890,
	"./LabVantage.png": 1891,
	"./Lantech.png": 1892,
	"./Lantechi.png": 1893,
	"./Levitate Technologies.png": 1894,
	"./Lexmark.png": 1895,
	"./Lightning Pick.png": 1896,
	"./Limble CMMS.png": 1897,
	"./Linde Material Handling.png": 1898,
	"./Lisk.png": 1899,
	"./Locus Technologies.png": 1900,
	"./Lydia Voice.png": 1901,
	"./MIR.png": 1902,
	"./MIT.png": 1903,
	"./MPulse Software.png": 1904,
	"./MS D365 - Remote Assist.png": 1905,
	"./Macawber Group.png": 1906,
	"./Machine Metrics.png": 1907,
	"./MaintainX.png": 1908,
	"./Maintenance Connection.png": 1909,
	"./Maintenance Partners.png": 1910,
	"./Malware bytes.png": 1911,
	"./MangoGem.png": 1912,
	"./Manhattan Associates.png": 1913,
	"./Marel.png": 1914,
	"./Markem-Imaje.png": 1915,
	"./MarketLauncher.png": 1916,
	"./Markforged.png": 1917,
	"./Master Control.png": 1918,
	"./Matthews Intelligent Identification.png": 1919,
	"./McAfee.png": 1920,
	"./McKinsey & Company.png": 1921,
	"./MercuryGate.png": 1922,
	"./Metis Kaplan.png": 1923,
	"./MiR.png": 1924,
	"./Microsoft.png": 1925,
	"./Minit.png": 1926,
	"./Mitsubishi Electric.png": 1927,
	"./Mobile Demand.png": 1928,
	"./MobileDemand.png": 1929,
	"./Mocana.png": 1930,
	"./Moellers Group.png": 1931,
	"./Monday.com.png": 1932,
	"./Mu Sigma.png": 1933,
	"./Multivac.png": 1934,
	"./Murata Machinery.png": 1935,
	"./Möllers Group.png": 1936,
	"./NEC.png": 1937,
	"./NavVis.png": 1938,
	"./NexusTec.png": 1939,
	"./NexusTek.png": 1940,
	"./Nilfisk FOOD.png": 1941,
	"./Nokia.png": 1942,
	"./Noodle Analytics, Inc..png": 1943,
	"./OMEGA Engineering.png": 1944,
	"./OMRON Corporation.png": 1945,
	"./OMRON Microscan.png": 1946,
	"./ORDINAL Software.png": 1947,
	"./OTTO Motors.png": 1948,
	"./Omron Microscan.png": 1949,
	"./Omron.png": 1950,
	"./Operator Systems.png": 1951,
	"./OpsVeda.png": 1952,
	"./Oracle.png": 1953,
	"./PAGO.png": 1954,
	"./PCMS ENG.png": 1955,
	"./PERCEPTO.png": 1956,
	"./PINC.png": 1957,
	"./PTC.png": 1958,
	"./Panasonic.png": 1959,
	"./Particle.png": 1960,
	"./Pegasystems.png": 1961,
	"./Pepperl + Fuchs.png": 1962,
	"./Petasense.png": 1963,
	"./Phoenix Contact.png": 1964,
	"./Pick-it 3D.png": 1965,
	"./Picomto.png": 1966,
	"./Pilgrim.png": 1967,
	"./Pixo VR.png": 1968,
	"./Plex.png": 1969,
	"./Poirier Group.png": 1970,
	"./Poka.png": 1971,
	"./Premier Labellers.png": 1972,
	"./ProLeit.png": 1973,
	"./Proceedix.png": 1974,
	"./Productivity Solutions.png": 1975,
	"./Productivity.png": 1976,
	"./Profitect.png": 1977,
	"./Prometheus.png": 1978,
	"./Prophesee.png": 1979,
	"./PwC.png": 1980,
	"./QPR.png": 1981,
	"./QT9 QMS.png": 1982,
	"./QT9 Software.png": 1983,
	"./QualityLine Production Technologies.png": 1984,
	"./Quentic.png": 1985,
	"./RE'FLEKT.png": 1986,
	"./ROBOPAC.png": 1987,
	"./Raymond.png": 1988,
	"./RealTrac.png": 1989,
	"./RealWear.png": 1990,
	"./Red on Line.png": 1991,
	"./Reflekt.png": 1992,
	"./Rexroth.png": 1993,
	"./Ripcord.png": 1994,
	"./Rise Technologies.png": 1995,
	"./Rizing.png": 1996,
	"./Robopac.png": 1997,
	"./Roboteq.png": 1998,
	"./Rockwell Automation.png": 1999,
	"./Rombit.png": 2000,
	"./RtTech Software.png": 2001,
	"./SAP SE.png": 2002,
	"./SAP.png": 2003,
	"./SAS.png": 2004,
	"./SEEBO.png": 2005,
	"./SI Systems.png": 2006,
	"./SIGHT MACHINE.png": 2007,
	"./SIGHTMACHINE.png": 2008,
	"./SIMONA AG.png": 2009,
	"./SLIMS by Genohm.png": 2010,
	"./SOFTOOLS.png": 2011,
	"./SSI Schaefer.png": 2012,
	"./STRIVR.png": 2013,
	"./SVA System Vertrieb Alexander.png": 2014,
	"./Sage.png": 2015,
	"./Salesforce.png": 2016,
	"./Samsung Electronics.png": 2017,
	"./Samsung.png": 2018,
	"./Sani-Matic.png": 2019,
	"./Sanitary Design Industries.png": 2020,
	"./Schneider Electric.png": 2021,
	"./Seebo.png": 2022,
	"./Seegrid 1.png": 2023,
	"./Seegrid 2.png": 2024,
	"./Seegrid.png": 2025,
	"./Selerant.png": 2026,
	"./Senseye.png": 2027,
	"./Sepasoft.png": 2028,
	"./Service Conseil Mindcore.png": 2029,
	"./ServiceNow.png": 2030,
	"./Sewio.png": 2031,
	"./Sharp Industries.png": 2032,
	"./Siemens.png": 2033,
	"./Sigga.png": 2034,
	"./Sight Machine.png": 2035,
	"./Simio.png": 2036,
	"./Simulanis.png": 2037,
	"./SingleHop.png": 2038,
	"./Sisense.png": 2039,
	"./SmarterChains.png": 2040,
	"./Software AG.png": 2041,
	"./Solarwinds MSP.png": 2042,
	"./Sophos.png": 2043,
	"./Sortly.png": 2044,
	"./Spiroflow.png": 2045,
	"./Stanford.png": 2046,
	"./Stratasys.png": 2047,
	"./SuitX.png": 2048,
	"./Sunquest.png": 2049,
	"./Swift Sensors.png": 2050,
	"./Swipe Guide.png": 2051,
	"./SwipeGuide.png": 2052,
	"./Swiss Log.png": 2053,
	"./Swisslog.png": 2054,
	"./Symantec.png": 2055,
	"./Synoptic Consulting.png": 2056,
	"./Systems Interface Inc.png": 2057,
	"./TAWI.png": 2058,
	"./TULIP.png": 2059,
	"./Talend.png": 2060,
	"./Tallyfy.png": 2061,
	"./Tata Consultancy Services.png": 2062,
	"./Techno Pak.png": 2063,
	"./The Hackett Group.png": 2064,
	"./The Training Room Online.png": 2065,
	"./Thermo Fisher Scientific.png": 2066,
	"./Tibbo Systems.png": 2067,
	"./Total Systems Development.png": 2068,
	"./Toyota Material Handling.png": 2069,
	"./Trendminer.png": 2070,
	"./Tsugami Rem Sales.png": 2071,
	"./Tulip Interfaces.png": 2072,
	"./Tulip.png": 2073,
	"./UL.png": 2074,
	"./UNIVERSAL ROBOTS.png": 2075,
	"./UP SKILL.png": 2076,
	"./Ubimax.png": 2077,
	"./Udemy.png": 2078,
	"./UiPath.png": 2079,
	"./Universal Robots.png": 2080,
	"./UpKeep.png": 2081,
	"./Upskill.png": 2082,
	"./VAIA Technologies.png": 2083,
	"./VARGO.png": 2084,
	"./VAULT Intelligence.png": 2085,
	"./VSH Connection Technology.png": 2086,
	"./VUZIX.png": 2087,
	"./Vecna Robotics.png": 2088,
	"./Veeva.png": 2089,
	"./Voiteq.png": 2090,
	"./Vorne Industries, Inc..png": 2091,
	"./WORKERBASE.png": 2092,
	"./Walkera.png": 2093,
	"./Wasp Barcode Technologies.png": 2094,
	"./Westfalia.png": 2095,
	"./WorkFusion.png": 2096,
	"./Wulftec.png": 2097,
	"./Xerox.png": 2098,
	"./Xometry.png": 2099,
	"./Xu Yuan Packaging.png": 2100,
	"./YASKAWA MOTOMAN.png": 2101,
	"./YardView.png": 2102,
	"./Zebra Technologies.png": 2103,
	"./Zelus.png": 2104,
	"./Zeppelin Systems.png": 2105,
	"./aimtec.png": 2106,
	"./ancra.png": 2107,
	"./apizee.png": 2108,
	"./aucobo.png": 2109,
	"./augury.png": 2110,
	"./banner.png": 2111,
	"./bastian.png": 2112,
	"./baumer.png": 2113,
	"./business/AVEVA.png": 2114,
	"./business/Advantech.png": 2115,
	"./business/Augury.png": 2116,
	"./business/Automation Anywhere.png": 2117,
	"./business/Baumer.png": 2118,
	"./business/Belden.png": 2119,
	"./business/BluePrism.png": 2120,
	"./business/Cisco.png": 2121,
	"./business/Cognex.png": 2122,
	"./business/Delta Electronics.png": 2123,
	"./business/Dematic.png": 2124,
	"./business/EY.png": 2125,
	"./business/FANUC.png": 2126,
	"./business/Fero Labs.png": 2127,
	"./business/Fetch Robotics.png": 2128,
	"./business/Getac.png": 2129,
	"./business/Intelex.png": 2130,
	"./business/KUKA.png": 2131,
	"./business/Limble CMMS.png": 2132,
	"./business/MaintainX.png": 2133,
	"./business/Omron Microscan.png": 2134,
	"./business/Panasonic.png": 2135,
	"./business/Petasense.png": 2136,
	"./business/Poka.png": 2137,
	"./business/Quentic.png": 2138,
	"./business/RE'FLEKT.png": 2139,
	"./business/Raymond.png": 2140,
	"./business/RealWear.png": 2141,
	"./business/Rockwell Automation.png": 2142,
	"./business/Siemens.png": 2143,
	"./business/Sight Machine.png": 2144,
	"./business/Swisslog.png": 2145,
	"./business/TULIP.png": 2146,
	"./business/Trendminer.png": 2147,
	"./business/UiPath.png": 2148,
	"./business/Universal Robots.png": 2149,
	"./business/UpKeep.png": 2150,
	"./business/Upskill.png": 2151,
	"./business/advantech.png": 2152,
	"./business/ancra.png": 2153,
	"./business/augury.png": 2154,
	"./business/banner.png": 2155,
	"./business/bastian.png": 2156,
	"./business/baumer.png": 2157,
	"./business/belden.png": 2158,
	"./business/etq.png": 2159,
	"./business/fluke.png": 2160,
	"./business/gensuite.png": 2161,
	"./business/infinityQs.png": 2162,
	"./business/intelex.png": 2163,
	"./business/joloda.png": 2164,
	"./business/kuka.png": 2165,
	"./business/mir.png": 2166,
	"./business/mobile demand.png": 2167,
	"./business/mobiledemand.png": 2168,
	"./business/omron microscan.png": 2169,
	"./business/omron.png": 2170,
	"./business/panasonic.png": 2171,
	"./business/raymond.png": 2172,
	"./business/robotiq.png": 2173,
	"./business/rockwell automation.png": 2174,
	"./business/rockwellAutomation.png": 2175,
	"./business/samsara.png": 2176,
	"./business/scnscyc.png": 2177,
	"./business/seebo.png": 2178,
	"./business/senseye.png": 2179,
	"./business/sigheMachine.png": 2180,
	"./business/swipeGuide.png": 2181,
	"./business/swipeguide.png": 2182,
	"./business/swisslog.png": 2183,
	"./business/univeral robots.png": 2184,
	"./business/universal robots.png": 2185,
	"./business/v fetch.png": 2186,
	"./business/vFetch.png": 2187,
	"./business/vecna.png": 2188,
	"./chiron.png": 2189,
	"./cisco.png": 2190,
	"./cognexa.png": 2191,
	"./cyberplan.png": 2192,
	"./e-Business Institute.png": 2193,
	"./eCompliance.png": 2194,
	"./edX.png": 2195,
	"./ei3 Corporation.png": 2196,
	"./emaint.png": 2197,
	"./eon reality.png": 2198,
	"./etq.png": 2199,
	"./evan.network.png": 2200,
	"./fetch robotics.png": 2201,
	"./ffly4u.png": 2202,
	"./fluke.png": 2203,
	"./gensuite.png": 2204,
	"./iAuditor.png": 2205,
	"./iQagent.png": 2206,
	"./illogic.png": 2207,
	"./infinityQs.png": 2208,
	"./intelex.png": 2209,
	"./joloda.png": 2210,
	"./mir.png": 2211,
	"./mobile demand.png": 2212,
	"./mobiledemand.png": 2213,
	"./nenok.png": 2214,
	"./omron.png": 2215,
	"./peak10.png": 2216,
	"./pilgrim.png": 2217,
	"./raymond.png": 2218,
	"./robotiq.png": 2219,
	"./rockwell automation.png": 2220,
	"./rockwellAutomation.png": 2221,
	"./samsara.png": 2222,
	"./seebo.png": 2223,
	"./senseye.png": 2224,
	"./sentryo.png": 2225,
	"./sigheMachine.png": 2226,
	"./skillsoft.png": 2227,
	"./swipeguide.png": 2228,
	"./swisslog.png": 2229,
	"./thinkstep.png": 2230,
	"./univeral robots.png": 2231,
	"./universal robots.png": 2232,
	"./v fetch.png": 2233,
	"./vFetch.png": 2234,
	"./vecna.png": 2235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1661;